window.moveAllDatesButton = function () {
    let footer = document.querySelector(".e-daterangepicker.e-popup .e-footer");
    let allDatesBtn = document.getElementById("allDatesBtn");
    if (footer && allDatesBtn && !footer.contains(allDatesBtn)) {
        footer.appendChild(allDatesBtn);
    }
};
